import React from 'react';
import { Link, IndexLink } from 'react-router';
import axios from '../../../../constants/axios.js';

class FixedAssetPayBill extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         invoiceDetails: {}
      };
   }


   componentDidMount() {
      const { invoiceId } = this.props.params;
      axios.get(`fixedAssets/getInvoiceDetailsById/${invoiceId}`)
         .then((res) => {
            this.setState({
               invoiceDetails: res.data
            });
         });
   }


   render() {
      const { invoiceDetails } = this.state;
      return (
         <div>
            <div className="row" >
               <div className="col-md-6" >
                  <p >InvoiceId: {invoiceDetails.id}</p >
                  <p className="text-success" >Vendor Name: {invoiceDetails.contact_name}</p >
                  <p >Amount: {invoiceDetails.total_amount}</p >
                  <p >Paid: {invoiceDetails.paid_amount}</p >
                  <p >Due: {invoiceDetails.due}</p >
                  <p >Memo: {invoiceDetails.memo}</p >
                  <p className="text-danger" >Invoice Created By: {invoiceDetails.invoice_created_by}</p >
                  <p >Date: {invoiceDetails.created_at}</p >
               </div>
               <div className="col-md-6" >
                  <address>
                     <pre>Address: {invoiceDetails.contact_address}</pre>
                     <pre>District: {invoiceDetails.district_name}</pre>
                     <pre>Thana: {invoiceDetails.thana_name}</pre>
                     <pre>Address Type: {invoiceDetails.contact_address_type_name}</pre>
                  </address>
               </div>
            </div>
            <hr />
            <div>
               <ul className="nav nav-tabs" >
                  <li>
                     <IndexLink to={`/fixedAsset/fixedAssetPayBill/${invoiceDetails.id}`}
                                activeStyle={{ color: 'red' }} >Full Payment</IndexLink>
                  </li>
                  <li>
                     <Link to={`/fixedAsset/fixedAssetPayBill/${invoiceDetails.id}/partialPayment`}
                           activeStyle={{ color: 'red' }} >Partial Payment
                        History</Link>
                  </li>
               </ul>
            </div>
            {this.props.children}
         </div>
      );
   }
}

FixedAssetPayBill.propTypes = {
   params: React.PropTypes.object,
   children: React.PropTypes.object
};

export default FixedAssetPayBill;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/FixedAsset/FixedAssetPayment/FixedAssetPayBill.js
 **/